<!-- <div>
    <h2>SEB Lockouts for {{examNo}}</h2>
</div> -->
<app-grid
    [columns]="columns"
    [rows]="data.tableRows"
    [tableParams]="data.tableParams"
    [gridName]="gridName"
    [multiSelect]="false"
    #origin
    [allowCopy]="false"
    (refreshDataFromServer)="refreshData($event)"
    (rowSelected)="setGridData($event)"
></app-grid>
